const dominioVilla = window.location.host.match(/villapay/g) || window.location.host.match(/villa/g);


const product = () => {
  if (dominioVilla && dominioVilla.length > 0) {
    return {
      name: 'Villa Pay',
      logo: 'https://app.qesh.ai/villa.png',
      background: '#005438',
      width: 50,
    };
  }

  return {
    name: 'Qesh',
    logo: 'https://app.qesh.ai/logo_q.png',
    background: '#f7f7f7',
    width: 30,
  };
};

export default product();
